<template>
  <div class="task-container">
    <div class="task-inner">
      <div class="department">
        <span @click="changeSelect('checked', 'todo')" :class="{ active: 'todo' === select.checked }">待审批</span>
        <span @click="changeSelect('checked', 'done')" :class="{ active: 'done' === select.checked }">已审批</span>
        <span @click="changeSelect('checked', 'apply')" :class="{ active: 'apply' === select.checked }">申请记录</span>
        <span @click="changeSelect('checked', 'copyfor')" :class="{ active: 'copyfor' === select.checked }">抄送</span>
      </div>
      <section>
        <div class="category" data-title="服务名称">
          <div>
            <span @click="changeSelect('employId')" :class="{ active: !select.employId }">全部</span>
            <span v-for="{ employId, employName, applyNumber } in serviceList" :key="employId"
              @click="changeSelect('employId', employId)" :class="{ active: employId === select.employId }">
              {{ `${employName}（${applyNumber}）` }}</span>
          </div>
        </div>
        <header>
          <el-button type="primary" @click="batchCheck" v-if="select.checked === 'todo'">批量审批</el-button>
          <div class="search">
            <el-input v-model="select.userName" placeholder="请输入申请人姓名" @change="getApplyList" clearable></el-input>
            <el-date-picker v-model="select.daterange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
              format="yyyy-MM-DD" value-format="yyyy-MM-DD" @change="getApplyList"></el-date-picker>
          </div>
        </header>
        <el-table height="500" :data="applyList" border ref="table"
          :header-cell-style="{ background: '#fff !important' }">
          <!-- 仅 待审批 显示 -->
          <el-table-column type="selection" align="center" width="60" v-if="select.checked === 'todo'"
            key="selection"></el-table-column>
          <el-table-column type="index" label="序号" align="center" width="80" key="index"></el-table-column>
          <el-table-column label="服务名称" prop="employName" align="center" key="employName"></el-table-column>
          <!-- 仅 发起记录 抄送 显示 -->
          <el-table-column label="业务分类" prop="categoryName" align="center" key="categoryName"
            v-if="select.checked === 'apply' || select.checked === 'copyfor'"></el-table-column>
          <!-- 仅 发起记录 不显示 -->
          <el-table-column label="申请人" prop="userName" align="center" key="userName"
            v-if="select.checked !== 'apply'"></el-table-column>
          <!-- 仅 抄送 不显示 -->
          <el-table-column label="申请时间" prop="createTime" align="center" key="createTime"
            v-if="select.checked !== 'copyfor'"></el-table-column>
          <!-- 仅 发起记录 显示 -->
          <el-table-column label="结束时间" prop="updateTime" align="center" key="updateTime"
            v-if="select.checked === 'apply'"></el-table-column>
          <!-- 仅 抄送 显示 -->
          <el-table-column label="结束时间" prop="createTime" align="center" key="createTime"
            v-if="select.checked === 'copyfor'"></el-table-column>
          <!-- 仅 已审批 发起记录 显示 -->
          <el-table-column label="审批状态" prop="approvalStatus" align="center"
            v-if="select.checked === 'done' || select.checked === 'apply'" key="approvalStatus">
            <template slot-scope="{ row }">
              <b class="status"
                :style="{ '--color': ['var(--mainColor)', 'var(--successColor)', 'var(--dangerColor)', 'var(--warningColor)', 'var(--warningColor)', 'var(--dangerColor)'][row.approvalStatus - 1] }">
                {{ ['审批中', '已通过', '未通过', '已撤销 ', '挂起 ', '已结束'][row.approvalStatus - 1] }}</b>
            </template>
          </el-table-column>
          <!-- 仅 抄送 显示 -->
          <el-table-column label="状态" prop="approvalStatus" align="center" v-if="select.checked === 'copyfor'"
            key="approvalStatus">
            <template slot-scope="{ row }">
              <b class="status"
                :style="{ '--color': ['var(--mainColor)', 'var(--warningColor)'][row.approvalStatus - 1] }">
                {{ ['已读', '未读'][row.approvalStatus - 1] }}</b>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="{ row }">
              <el-link :underline="false" v-if="select.checked === 'apply'" @click="revoke(row)"
                :disabled="row.approvalStatus !== 1" style="margin-right: 10px;">撤回</el-link>
              <el-link :underline="false" type="primary" @click="openDialog(row)">{{ select.checked === 'todo' ? '审批' :
                '详情' }}</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="select.pageParam.current" :page-size.sync="select.pageParam.size"
          layout="total,prev,pager,next" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </section>
    </div>

    <CheckDialog ref="checkDialog" />
  </div>
</template>

<script>
import * as api from './api'
export default {
  name: 'Task',
  components: { CheckDialog: () => import('./checkDialog.vue') },
  data() {
    return {
      departmentList: [],
      categoryList: [],
      select: {
        pageParam: {
          current: 1,
          size: 10
        }
      },
      serviceList: [],
      applyList: [],
      total: 0
    }
  },
  async created() {
    const { checked } = this.$route.query
    this.select.checked = checked || 'todo'
    await this.getServiceList()
    this.getApplyList()
  },
  beforeUpdate() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
  methods: {
    async getServiceList() {
      this.serviceList = []
      switch (this.select.checked) {
        case 'todo':
          const { data: data1 } = await api.getTodoServiceList()
          this.serviceList = data1.employList
          break
        case 'done':
          const { data: data2 } = await api.getDoneServiceList()
          this.serviceList = data2.employList
          break
        case 'apply':
          const { data: data3 } = await api.getApplyServiceList()
          this.serviceList = data3.employList
          break
        case 'copyfor':
          const { data: data4 } = await api.getCopyforServiceList()
          this.serviceList = data4.employList
          break
        default:
      }
      this.select = {
        employId: this.select.employId,
        checked: this.select.checked,
        pageParam: {
          current: 1,
          size: 10
        }
      }
    },
    async getApplyList() {
      this.applyList = []
      this.select.startDate = this.select.daterange ? this.select.daterange[0] : ''
      this.select.endDate = this.select.daterange ? this.select.daterange[1] : ''

      switch (this.select.checked) {
        case 'todo':
          const { data: data1 } = await api.getTodoApplyList(this.select)
          this.applyList = data1.applyList
          this.total = data1.total
          break
        case 'done':
          const { data: data2 } = await api.getDoneApplyList(this.select)
          this.applyList = data2.applyList
          this.total = data2.total
          break
        case 'apply':
          const { data: data3 } = await api.getApplyList(this.select)
          this.applyList = data3.userApplyList
          this.total = data3.total
          break
        case 'copyfor':
          const { data: data4 } = await api.getCopyforApplyList(this.select)
          this.applyList = data4.copyList
          this.total = data4.total
          break
        default:
      }
    },
    async changeSelect(key, val) {
      this.$set(this.select, key, val)
      await this.getServiceList()
      this.getApplyList()
    },
    // 撤回申请
    revoke(row) {
      this.$confirm('确定撤回申请吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        await api.revokeApply({ applyId: row.applyId })
        this.$message.success('撤回成功')
        this.getApplyList()
      }).catch(() => { })
    },
    async openDialog(row) {
      const { checkDialog } = this.$refs
      const { data } = await api.getCheckedDetail(row.applyId)

      data.flowList = [
        {
          taskName: '提交',
          userName: data.applyInfo.userName,
          comment: {
            type: '7',
            comment: '--'
          },
          finishTime: data.applyInfo.createTime
        },
        ...data.flowList,
        {
          taskName: '结束',
          userName: '系统',
          comment: {
            type: '--',
            comment: '--'
          },
          finishTime: '--'
        },
        {
          taskName: '抄送',
          userName: data.copyUserList.length ? data.copyUserList.map(item => item.userName).join(',') : '--',
          comment: {
            type: '8',
            comment: '--'
          },
          finishTime: '--'
        },
      ]
      checkDialog.checkedDetail = data
      checkDialog.title = data.applyInfo.employName
      if (this.select.checked == 'todo') checkDialog.taskId = row.taskId
      checkDialog.visible = true
    },
    batchCheck() {
      const selection = this.$refs.table.selection
      if (!selection.length) return this.$message.warning('请选择要审批的服务')
      this.$confirm('确定审批选中的服务吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        await api.agreeApply({
          taskIdList: selection.map(item => item.taskId),
          comment: ''
        })
        this.$message.success('审批成功')
        this.getApplyList()
      }).catch(() => { })
    },
    handleSizeChange(val) {
      this.select.pageParam.current = 1
      this.select.pageParam.size = val
      this.getApplyList()
    },
    handleCurrentChange(val) {
      this.select.pageParam.current = val
      this.getApplyList()
    }
  }
}
</script>

<style lang="scss" scoped>
.task-container {
  min-height: calc(100vh - 340px);
  background: #fff;

  .task-inner {
    width: var(--inner-width);
    margin: auto;
    padding: 50px 0 100px;
    display: flex;
    gap: 40px;

    .department {
      width: 250px;

      span {
        display: block;
        height: 50px;
        background: #eee;
        color: #333;
        font-size: 14px;
        line-height: 50px;
        cursor: pointer;
        padding-left: 20px;
        border-bottom: 1px solid #fff;
        position: relative;

        &::before {
          content: '';
          width: calc(100% - 6px);
          height: 100%;
          position: absolute;
          right: 0;
          background: #fff;
          opacity: 0;
        }

        &.active {
          background: linear-gradient(to right, $mainColor, #fff);
          color: #fff;
          font-weight: bold;

          &::before {
            opacity: .4;
          }
        }
      }
    }

    section {
      flex: 1;

      .category {
        display: flex;
        gap: 20px;

        &::before {
          content: attr(data-title);
          color: #999;
          transform: translateY(8px);
          font-size: 17px;
          font-weight: bold;
        }

        div {
          flex: 1;
          display: flex;
          gap: 20px;
          flex-wrap: wrap;

          span {
            background: #eee;
            padding: 8px 20px;
            color: #333;
            border-radius: 4px;
            cursor: pointer;
            transition: 300ms ease-in-out;

            &:hover {
              color: $mainColor;
            }

            &.active {
              background: $mainColor;
              color: #fff;
              font-weight: bold;
            }
          }
        }
      }

      header {
        display: flex;
        margin: 40px 0 20px;

        .search {
          margin-left: auto;
          display: flex;
          gap: 10px;

          .el-input {
            width: 250px;
          }
        }
      }

      .el-table {
        margin-bottom: 20px;

        .status {
          border: 1px solid var(--color);
          font-size: 12px;
          padding: 2px 4px;
          border-radius: 2px;
          color: var(--color)
        }
      }
    }
  }
}
</style>